import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PatSympService {

  constructor() { }

  getDurationFromEffectivePeriod(effectivePeriod: { start?: string; end?: string } | undefined): string {
    if (!effectivePeriod || !effectivePeriod.start) {
      return '—';
    }
    const startDate = new Date(effectivePeriod.start);
    const endDate = effectivePeriod.end ? new Date(effectivePeriod.end) : new Date();
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} day(s)`;
  }
}
